import React from 'react'
import { Menu } from 'antd'
import {
  CloudUploadOutlined, CloudDownloadOutlined, GlobalOutlined,
  CrownOutlined, SyncOutlined,
  FileTextOutlined, BgColorsOutlined, InfoCircleOutlined,
  UserSwitchOutlined, CodeOutlined, NotificationOutlined,
  CloudServerOutlined, CustomerServiceOutlined,
  GoldOutlined, GiftOutlined, MessageOutlined
} from '@ant-design/icons'
import DataBackup from './settings/DataBackup'
import DataImport from './settings/DataImport'
import NetworkProxy from './settings/NetworkProxy'
import AccountCenter from './settings/AccountCenter'
import AutoUpdate from './settings/AutoUpdate'
import OperationLog from './settings/OperationLog'
import ThemeAppearance from './settings/ThemeAppearance'
import AboutSoftware from './settings/AboutSoftware'
import MemberManagement from './settings/MemberManagement'
import ActivationCodeManage from './settings/ActivationCodeManage'
import AnnouncementPush from './settings/AnnouncementPush'
import VersionManage from './settings/VersionManage'
import SupportTickets from './settings/SupportTickets'
import MembershipPlans from './settings/MembershipPlans'
import ReferralConfig from './settings/ReferralConfig'
import TicketManage from './settings/TicketManage'

const MEMBER_TABS = [
  { key: 'account', label: '账号中心', icon: <CrownOutlined /> },
  { key: 'backup', label: '数据备份', icon: <CloudUploadOutlined /> },
  { key: 'import', label: '数据导入', icon: <CloudDownloadOutlined /> },
  { key: 'proxy', label: '网络代理', icon: <GlobalOutlined /> },
  { key: 'update', label: '自动更新', icon: <SyncOutlined /> },
  { key: 'logs', label: '操作日志', icon: <FileTextOutlined /> },
  { key: 'theme', label: '主题外观', icon: <BgColorsOutlined /> },
  { key: 'about', label: '关于软件', icon: <InfoCircleOutlined /> },
  { key: 'tickets', label: '工单客服', icon: <CustomerServiceOutlined /> }
]

const ADMIN_TABS = [
  { key: 'member_manage', label: '会员管理', icon: <UserSwitchOutlined /> },
  { key: 'code_manage', label: '激活码管理', icon: <CodeOutlined /> },
  { key: 'announce', label: '公告推送', icon: <NotificationOutlined /> },
  { key: 'version', label: '版本管理', icon: <CloudServerOutlined /> },
  { key: 'membership_plans', label: '会员方案', icon: <GoldOutlined /> },
  { key: 'referral_config', label: '推荐奖励', icon: <GiftOutlined /> },
  { key: 'ticket_manage', label: '工单管理', icon: <MessageOutlined /> }
]

const PAGES = {
  account: <AccountCenter />, backup: <DataBackup />, import: <DataImport />, proxy: <NetworkProxy />,
  update: <AutoUpdate />, logs: <OperationLog />, theme: <ThemeAppearance />,
  about: <AboutSoftware />, tickets: <SupportTickets />,
  member_manage: <MemberManagement />, code_manage: <ActivationCodeManage />,
  announce: <AnnouncementPush />, version: <VersionManage />,
  membership_plans: <MembershipPlans />, referral_config: <ReferralConfig />,
  ticket_manage: <TicketManage />
}

export default function SettingsPage({ user }) {
  const [activeKey, setActiveKey] = React.useState('account')
  const isAdmin = user?.role === 'admin'

  const tabs = isAdmin ? [...MEMBER_TABS, ...ADMIN_TABS] : MEMBER_TABS

  return (
    <div style={{ flex: 1, height: '100%', display: 'flex', background: '#f5f6fa' }}>
      <div style={{ width: 180, flexShrink: 0, background: '#fff', borderRight: '1px solid #e8e8e8', overflow: 'auto' }}>
        <div style={{ padding: '12px 16px', fontWeight: 600, fontSize: 14, borderBottom: '1px solid #f0f0f0', color: '#333' }}>
          设置
        </div>
        <Menu mode="inline" selectedKeys={[activeKey]} onClick={e => setActiveKey(e.key)}
          items={tabs} style={{ borderRight: 0 }} />
      </div>
      <div style={{ flex: 1, overflow: 'auto', padding: 16 }}>
        {PAGES[activeKey]}
      </div>
    </div>
  )
}
